import { LawReportActions } from 'src/store/actions/lawReportActions';
const initialState = {
    data: [],
    loading: false
};
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case LawReportActions.GET_LAW_REPORT_REQUEST: {
            return ({
                ...state,
                loading: true
            });
        }
        case LawReportActions.GET_LAW_REPORT_SUCCESS: {
            return ({
                ...state,
                loading: false,
                data: payload || []
            });
        }
        case LawReportActions.GET_LAW_REPORT_FAIL: {
            return ({
                ...state,
                loading: false
            });
        }
        default: return state;
    }
};
